import React from 'react'
import styled from 'styled-components'
import BSModal from 'react-bootstrap/Modal'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { createAsyncThunk } from '@reduxjs/toolkit'
import Time from './Time'
import Bookmark from '../../goodiebag/Bookmark'
import { _ } from '../../../utils/localization'
import { Goodiebag, GoodiebagType } from '../../goodiebag/types'
import { RetrieveProgramDetailResponse, Space } from '../../../types/swagger'
import useParams from '../../../hooks/useParams'
import getPathForSpace from '../../../utils/spaces/getPathForSpace'
import { closeAllModal } from '../../modals/modalSlice'
import { collapse } from '../redux/expandFooterSlice'
import PerformerProfile from '../../auth/components/PerformerProfile'
import CustomButton from '../../../components/CustomButton'

const S = {
    ItemDetails: styled.div`
    `,

    HeaderContent: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    `,

    Title: styled.h6`
        font-weight: bold;
    `,

    VerticalLine: styled.span`
        margin: 0 6px;
    `,

    SubTitle: styled.div`
        display: flex;
        align-content: center;
        align-items: center;
        font-size: 12px;
    `,

    AlignActions: styled.div`
        margin-bottom: auto;
        margin-top: auto;
        margin-right: 8px;
    `,

    EscapeContainer: styled.div`
        margin: 0 -16px;
    `,

    Image: styled.img`
        object-fit: cover;
        width: 100%;
        min-height: 100px;  // to prevent jump in height after load                       
    `,

    Description: styled.div`
        margin-top: 12px;
        max-height: 25vh;
        overflow-y: auto;
    `,

    HeaderBar: styled.p`
        margin-top: 32px;
        margin-bottom: 16px;
        padding: 4px 16px;
        background-color: #386080;
        color: white;
        font-weight: bold;
    `,
    Link: styled(Link)`
        margin-right: 24px;
        text-decoration: none !important;
    `,
}

export const createBookmark = (id: number): Goodiebag => ({
    id,
    type: GoodiebagType.ProgramItem,
})

const handleEnterClick = createAsyncThunk(
    'HANDLE_ENTER_CLICK',
    (__, thunkAPI) => {
        thunkAPI.dispatch(closeAllModal())
        thunkAPI.dispatch(collapse())
    },
)

const ItemDetails = (item: RetrieveProgramDetailResponse) => {
    const { location } = useHistory()
    const params = useParams()
    const dispatch = useDispatch()
    const path = getPathForSpace(item.virtual_space as Space, params)
    const enterLink = item.meeting_id
        ? `${path}?meetingId=${item.meeting_id}`
        : path
    return (
        <S.ItemDetails>
            <BSModal.Header closeButton style={{ paddingTop: 0 }}>
                <S.HeaderContent>
                    <div>
                        <S.Title>{item.name}</S.Title>
                        <S.SubTitle>
                            <Time start_date={item.start_date} end_date={item.end_date} />
                            <S.VerticalLine>|</S.VerticalLine>
                            <span>{item.virtual_space.name}</span>
                        </S.SubTitle>
                    </div>

                    <S.AlignActions>
                        {enterLink !== location.pathname
                            && (
                                <S.Link to={enterLink} onClick={() => dispatch(handleEnterClick())}>
                                    <CustomButton variant="success">
                                        {_('item.details_modal.join_button')}
                                    </CustomButton>
                                </S.Link>
                            )}
                        <Bookmark item={createBookmark(item.id)} style={{ marginRight: 10 }} />
                    </S.AlignActions>
                </S.HeaderContent>
            </BSModal.Header>

            { item.image
                && (
                    <S.EscapeContainer>
                        <S.Image src={item.image} alt="" />
                    </S.EscapeContainer>
                )}

            <S.Description>
                <div dangerouslySetInnerHTML={{ __html: item.description }} />
            </S.Description>

            {
                item.performers.length > 0
                && (
                    <S.EscapeContainer>
                        <S.HeaderBar>
                            {_('item.details_modal.related_speakers')}
                        </S.HeaderBar>
                    </S.EscapeContainer>
                )
            }

            { item.performers.map((performer) => (
                <PerformerProfile
                    key={performer.id}
                    performer={performer}
                />
            )) }
        </S.ItemDetails>
    )
}

export default ItemDetails
